import axios from "axios";

const baseUriOpenSrv = `${process.env.VUE_APP_BASE_URL}/openapi/api/v1`;

export default {
  checkAgencyInfo(agcyInfo) {
    return axios({
      method: "get",
      url: baseUriOpenSrv + "/agency/info/valid",
      params: {
        brkrNm: agcyInfo.ceoName,
        bsnmCmpnm: agcyInfo.officeName,
        regNum: agcyInfo.officeRegNum,
        numOfRows: 1000,
        pageNo: 1
      },
      validateStatus: () => true,
      timeout: 8000
    })
      .then(res => {
        console.log(res);
        return {
          status: res.status,
          payload: res.data.payload,
          message: res.data.message,
          detail: res.data.detail
        };
      })
      .catch(err => {
        console.error(err);
        return {
          status: 500,
          message: "서버통신 오류",
          detail: {
            code: -1,
            message: "서버통신 오류"
          }
        };
      });
  },

  getRegExpos(propInfo) {
    return axios({
      method: "get",
      url: baseUriOpenSrv + "/building/register/expos",
      params: {
        sigunguCd: propInfo.sigunguCd,
        bjdongCd: propInfo.bjdongCd,
        bun: propInfo.bun,
        ji: propInfo.ji,
        sizePerPage: 10000
      },
      validateStatus: () => true,
      timeout: 8000
    })
      .then(res => {
        console.log(res);
        return {
          status: res.status,
          payload: res.data.payload,
          message: res.data.message,
          detail: res.data.detail
        };
      })
      .catch(err => {
        console.error(err);
        return {
          status: 500,
          message: "서버통신 오류",
          detail: {
            code: -1,
            message: "서버통신 오류"
          }
        };
      });
  },

  getAllFlrInfo(propInfo) {
    return axios({
      method: "get",
      url: baseUriOpenSrv + "/building/register/floor/info",
      params: {
        sigunguCd: propInfo.sigunguCd,
        bjdongCd: propInfo.bjdongCd,
        bun: propInfo.bun,
        ji: propInfo.ji,
        floor: propInfo.floor,
        sizePerPage: 10000
      },
      validateStatus: () => true,
      timeout: 8000
    })
      .then(res => {
        console.log(res);
        return {
          status: res.status,
          payload: res.data.payload,
          message: res.data.message,
          detail: res.data.detail
        };
      })
      .catch(err => {
        console.error(err);
        return {
          status: 500,
          message: "서버통신 오류",
          detail: {
            code: -1,
            message: "서버통신 오류"
          }
        };
      });
  },

  getAllPropHoFlr(propInfo) {
    return axios({
      method: "get",
      url: baseUriOpenSrv + "/prop/ho/flr",
      params: {
        sigunguCd: propInfo.sigunguCd,
        bjdongCd: propInfo.bjdongCd,
        bun: propInfo.bun,
        ji: propInfo.ji,
        dongNm: propInfo.dongNm,
        sizePerPage: 10000
      },
      validateStatus: () => true,
      timeout: 8000
    })
      .then(res => {
        console.log(res);
        return {
          status: res.status,
          payload: res.data.payload,
          message: res.data.message,
          detail: res.data.detail
        };
      })
      .catch(err => {
        console.error(err);
        return {
          status: 500,
          message: "서버통신 오류",
          detail: {
            code: -1,
            message: "서버통신 오류"
          }
        };
      });
  },
  getPropDetailInfo(propInfo) {
    return axios({
      method: "get",
      url: baseUriOpenSrv + "/prop/detail/info",
      params: {
        sigunguCd: propInfo.sigunguCd,
        bjdongCd: propInfo.bjdongCd,
        bun: propInfo.bun,
        ji: propInfo.ji,
        dongNm: propInfo.dongNm,
        hoNm: propInfo.hoNm,
        floor: propInfo.floor,
        sizePerPage: 10000
      },
      validateStatus: () => true,
      timeout: 8000
    })
      .then(res => {
        console.log(res);
        return {
          status: res.status,
          payload: res.data.payload,
          message: res.data.message,
          detail: res.data.detail
        };
      })
      .catch(err => {
        console.error(err);
        return {
          status: 500,
          message: "서버통신 오류",
          detail: {
            code: -1,
            message: "서버통신 오류"
          }
        };
      });
  },
  getPropInfo(propInfo) {
    return axios({
      method: "get",
      url: baseUriOpenSrv + "/prop/info",
      params: {
        sigunguCd: propInfo.sigunguCd,
        bjdongCd: propInfo.bjdongCd,
        bun: propInfo.bun,
        ji: propInfo.ji,
        sizePerPage: 10000
      },
      validateStatus: () => true,
      timeout: 8000
    })
      .then(res => {
        console.log(res);
        return {
          status: res.status,
          payload: res.data.payload,
          message: res.data.message,
          detail: res.data.detail
        };
      })
      .catch(err => {
        console.error(err);
        return {
          status: 500,
          message: "서버통신 오류",
          detail: {
            code: -1,
            message: "서버통신 오류"
          }
        };
      });
  },
  getAptRentData(reqInfo) {
    return axios({
      method: "get",
      url: baseUriOpenSrv + "/apt/rent/data",
      params: {
        dealDate: reqInfo.dealDate,
        regionCode: reqInfo.regionCode
      },
      validateStatus: () => true,
      timeout: 8000
    })
      .then(res => {
        console.log(res);
        return {
          status: res.status,
          payload: res.data.payload,
          message: res.data.message,
          detail: res.data.detail
        };
      })
      .catch(err => {
        console.error(err);
        return {
          status: 500,
          message: "서버통신 오류",
          detail: {
            code: -1,
            message: "서버통신 오류"
          }
        };
      });
  },
  getOffiRentData(reqInfo) {
    return axios({
      method: "get",
      url: baseUriOpenSrv + "/offi/rent/data",
      params: {
        dealDate: reqInfo.dealDate,
        regionCode: reqInfo.regionCode
      },
      validateStatus: () => true,
      timeout: 8000
    })
      .then(res => {
        console.log(res);
        return {
          status: res.status,
          payload: res.data.payload,
          message: res.data.message,
          detail: res.data.detail
        };
      })
      .catch(err => {
        console.error(err);
        return {
          status: 500,
          message: "서버통신 오류",
          detail: {
            code: -1,
            message: "서버통신 오류"
          }
        };
      });
  },

  getRhRentData(reqInfo) {
    return axios({
      method: "get",
      url: baseUriOpenSrv + "/rh/rent/data",
      params: {
        dealDate: reqInfo.dealDate,
        regionCode: reqInfo.regionCode
      },
      validateStatus: () => true,
      timeout: 8000
    })
      .then(res => {
        console.log(res);
        return {
          status: res.status,
          payload: res.data.payload,
          message: res.data.message,
          detail: res.data.detail
        };
      })
      .catch(err => {
        console.error(err);
        return {
          status: 500,
          message: "서버통신 오류",
          detail: {
            code: -1,
            message: "서버통신 오류"
          }
        };
      });
  },
  getShRentData(reqInfo) {
    return axios({
      method: "get",
      url: baseUriOpenSrv + "/sh/rent/data",
      params: {
        dealDate: reqInfo.dealDate,
        regionCode: reqInfo.regionCode
      },
      validateStatus: () => true,
      timeout: 8000
    })
      .then(res => {
        console.log(res);
        return {
          status: res.status,
          payload: res.data.payload,
          message: res.data.message,
          detail: res.data.detail
        };
      })
      .catch(err => {
        console.error(err);
        return {
          status: 500,
          message: "서버통신 오류",
          detail: {
            code: -1,
            message: "서버통신 오류"
          }
        };
      });
  }
};
